import { useTranslation } from 'react-i18next';

const SecondaryButton = (props) => {
    const { t } = useTranslation();
    return ( 
        <button
            style={{
                ...props.style,
                cursor: 'pointer',
                touchAction: 'manipulation',
                WebkitTapHighlightColor: 'transparent',
                transition: 'transform 0.2s, background-color 0.2s'
            }}
            onClick={props.handleFunc}
            onTouchStart={(e) => {
                e.currentTarget.style.transform = 'scale(0.98)';
            }}
            onTouchEnd={(e) => {
                e.currentTarget.style.transform = '';
            }}
        >
            {t(props.buttonText)}
        </button>
    )
}
export default SecondaryButton;